import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import Chat from '../pages/Chat/Chat';
import ManagementDefaultDashboard from '../pages/ManagementDefaultDashboard';
import AddWidget from '../pages/AddWidget';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>
                <Route
                    path='chat'
                    element={
                        <AuthProtected>
                            <Chat/>
                        </AuthProtected>
                    }
                    exact={true}
                />
                {/* <Route
                    path='management-default-dashboard'
                    element={
                        <AuthProtected>
                            <ManagementDefaultDashboard/>
                        </AuthProtected>
                    }
                    exact={true}
                />
                <Route
                    path='management-default-dashboard/add-widget'
                    element={
                        <AuthProtected>
                            <AddWidget isDefault={true}/>
                        </AuthProtected>
                    }
                    exact={true}
                /> */}
                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <VerticalLayout>{route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>
                
            </Routes>
        </React.Fragment>
    );
};

export default Index;